module.exports = __webpack_public_path__ + "assets/img/img151.dbe95238.png";